import { createSlice } from "@reduxjs/toolkit";
import { referringProviderAction } from "../actions/referringProviderAction";

const initialState = {
  showReferringProviderModal: false,
  showDeleteConfirmationModal: false,
  isUpdateOperation: false,
  isProcessing: false,
  selectedReferringProvider: null,
};

const referringProviderSlice = createSlice({
  name: "referringProvider",
  initialState,
  reducers: referringProviderAction,
});

export const {
  setShowReferringProviderModal,
  setIsProcessing,
  setIsUpdateOperation,
  setSelectedReferringProvider,
  setShowDeleteConfirmationModal,
} = referringProviderSlice.actions;
export default referringProviderSlice.reducer;
